'use strict'
import { App } from '../../app/config/app.js'
import { default as Component } from '../component.js'

class DropdownInput extends Component
{
	init()
	{
		this.input = this.element.querySelector('input')
		this.toggle = this.element.querySelector('button.dropdown-toggle')
		this.element.addEventListener('click', this.onClick.bind(this))
		this.viewOptions = this.element.querySelector('.dropdown-menu[ui-view]')?.getAttribute('ui-view')
		if (this.viewOptions)
		{
			this.element.addEventListener('view.render', e =>
			{
				if (e.detail.view.name == this.viewOptions)
					this.select(this.element.dataset.autoselect || this.input.value)
			})
		}
	}

	select(value)
	{
		const selected = this.element.querySelector('a[data-value="' + value + '"]')

		if (selected == null)
		{
			//console.warn('DropdownInput.select(): missing requested value', { dropdown: this, value })
			this.element.dataset.autoselect = value
			return
		}
		else
			delete this.element.dataset.autoselect

		// Map selected dataset to input dataset
		for (let i in selected.dataset)
			this.input.dataset[i] = selected.dataset[i]
		this.input.dataset.valuePrevious = this.input.value

		// Set the toggle value display
		this.toggle.innerHTML = '<div>' + (selected.dataset.title || selected.innerHTML) + '</div><i class="fa fa-caret-down"></i>'

		// Ensure selected option has selected class
		if (!selected.classList.contains('selected'))
		{
			this.element.querySelectorAll('.dropdown-menu li a.selected').forEach(a => a.classList.remove('selected'))
			selected.classList.add('selected')
		}

		const changed = value != this.input.value
		// Trigger change if necessary
		if (changed)
		{
			this.input.value = value
			this.input.dispatchEvent(new Event('change', { bubbles: true }))
		}

		this.element.dispatchEvent(new CustomEvent('dropdown.select', { bubbles: true, detail: { changed, option: selected, input: this.input } }))
		return selected
	}

	onClick(e)
	{
		e.preventDefault()
		let selected = e.target.closest('a')

		if (e.target.parentElement.matches('.pager') || selected?.parentElement?.matches('.pager'))
		{
			e.stopPropagation()
			if (selected)
				App.Action.cache(selected.getAttribute('ui-action'))?.run(selected)
		}

		if (selected)
			this.select(selected.dataset.value)
	}
}

export default DropdownInput
